<template>
  <v-container class="login-container">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <form autocomplete="off">
        <v-col align="center">
        <!-- 
          <v-img
            style="margin-bottom: 1rem"
            width="240"            
            contain
            src="@/assets/logo.svg"
          />
        -->
        <!--
            padding="100px 0px 0px 0px"      
            width="248"
            height="248" 
        -->
          <v-img
            style="margin-bottom: 1rem"
        
            contain
            src="@/assets/logo_image.svg"
          />

        </v-col>
        <!-- <p class="web3pays-subtitle white--text mt-4">
          Web 3.0 기반 통합 포인트<br />장애인후원 포인트 주관사
        </p> -->
        
        <!-- <validation-provider name="emil" rules="required|email">
          <v-text-field
            type="email"
            :label="$t('login.id')"
            v-model.trim="email"
            ref="email"
            v-on:keyup.enter="focusPassword"
          ></v-text-field>
        </validation-provider>
        <validation-provider name="password" rules="required">
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :label="$t('login.password')"
            v-model.trim="password"
            @click:append="showPassword = !showPassword"
            v-on:keyup.enter="submit"
            ref="password"
          ></v-text-field>
        </validation-provider> -->
        <!-- <div class="text-h5 font-weight-bold">안녕하세요.</div>
        <div class="text-h5 font-weight-bold">
          <span class="primary--text">PLAPAY</span> 입니다.
        </div>
        <div class="text-h5 font-weight-bold">휴대전화 번호를 입력하세요.</div> -->
        <validation-provider ref="phone" name="phone" rules="required">
          <v-text-field
            type="number"
            placeholder="01000000000"
            v-model="phone"
            class="my-4 text-h5"
            hide-details
            @keypress="onKeydown"
            v-on:keyup.enter="submit"
          >
          </v-text-field>
        </validation-provider>
        <v-alert
          v-model="alert"
          type="error"
          dense
          outlined
          transition="scroll-y-transition"
          class="text-body-2"
        >
          {{ errors }}
        </v-alert>

        <!-- <v-row align-content="center" justify="space-between">
          <div>
            <v-checkbox v-model="autoLogin">
              <template v-slot:label>
                <span class="text-subtitle-2 font-weight-bold">{{
                  $t('login.autoLogin')
                }}</span>
              </template>
            </v-checkbox>
          </div>
          <div class="links">
            <router-link class="link-item" to="/signup">
              <span class="text-subtitle-2 font-weight-bold">{{
                $t('login.signup')
              }}</span>
            </router-link>
            <router-link class="link-item" to="/password">
              <span class="text-subtitle-2 font-weight-bold">
                {{ $t('login.forgot') }}
              </span>
            </router-link>
          </div>
        </v-row> -->
        <v-btn
          @click="submit"
          class="font-weight-bold bottom-disable-p"
          color="primary"
          block
          x-large
          :disabled="loading || invalid"
        >
          {{$t('login.login')}} / {{$t('login.signup')}}
        </v-btn>

        <div v-if="isGsiAllowed" style="margin-top: 12px; text-align:center;" class="white--text">
          또는
        </div>
        <div v-if="isGsiAllowed" id="gsi-btn" style="margin-top: 12px; display:flex; justify-content:center;"></div>
      </form>
    </validation-observer>
    
  </v-container>
</template>

<script>
import { required, email } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate'
import { loginSuccess } from '@/api/native/native'

setInteractionMode('eager')

export default {
  data: () => ({
    phone: '',
    token: '',
    errors: '',
    autoLogin: false,
    alert: false,
    showPassword: false,
    clientIp: null,
  }),
  props: ['recommend'],

  computed: {
    is_login() {
      return this.$store.getters.is_login
    },
    loading() {
      return this.$store.getters.loading
    },
    // Allow Google Sign-In only for specific client IPs
    isGsiAllowed() {
      const allowed = ['221.148.15.70', '210.178.173.153']
      return true ; //allowed.includes(this.clientIp)
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mounted() {
    // Load Google SDK then fetch IP and initialize GSI if allowed
    this.ensureGsiScript().then(() => {
      this.fetchClientIp().then(() => {
        if (this.isGsiAllowed) {
          this.initGoogle()
        }
      })
    })
  },
  created() {
    extend('required', {
      ...required,
      message: this.$t('login.requiredMessage'),
    })
    extend('email', {
      ...email,
      message: this.$t('login.emailMessage'),
    })

      console.log("recommend : " , this.recommend   )  ;

    if (this.$route.query.psite) this.$cookies.set('psite', this.$route.query.psite) ; 
    
    this.$cookies.remove('recommend')
    if ( this.recommend  ) {      
      this.$cookies.set('recommend',  this.recommend  )
    }  ; 
  },
  methods: {
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()
      if (e.target.value.length > 10) e.preventDefault()
    },
    focusPassword() {
      this.$refs.password.focus()
    },
    filterKo() {
      const koreanRegex = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g
      return this.password.replace(koreanRegex, '')
    },
    submit() {
      this.$store.commit('loading', true)



      if (this.$refs.observer.validate()) {
        const params = {
          phone: this.phone.trim(),
          token: this.token.trim(),
        }

        const regx = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/
        if ( !regx.test(params.phone)) { 
          this.$store.commit('loading', false)
          this.alert = true
          this.errors = '올바른 휴대폰 번호를 입력해주세요.' ;           
          return ; 
        }  ; 


        this.$store
          .dispatch('LOGIN', params)
          .then((res) => {
            if (!res) {
              throw new Error('no response')
            } else if (res.type === 'new') {
              this.submit()
            } else if (res.code === 'auth') {
              // if (this.autoLogin) {
              //   localStorage.accessToken = res.token
              // }
              // this.$store.dispatch('FETCH_USERINFO').then((res) => {
              // this.$store.commit('loading', false)

              //   try {
              //     loginSuccess(this.email, res.token)
              //   } catch (error) {
              //     this.$store.commit('loading', false)
              //     console.log(error)
              //   }
              //   if (!res.data.user.auth_sms || res.data.user.auth_sms === 'N') {
              //     this.$router.push('/phone/verify')
              //     return
              //   }

              //   this.$store.commit('activeMenu', 'home')
              // })
              this.$store.commit('loading', false)
              this.$router.replace({
                name: 'verify',
                params: { phone: params.phone  ,firstLogin : res.first },
              })
            } else if (res.code === 'email') {
              this.$store
                .dispatch('SEND_VERIFY_CODE', {
                  email: params.email,
                })
                .then((response) => {
                  this.$store.commit('loading', false)
                  if (response.data.status) {
                    this.$router.push({
                      name: 'verify',
                      params: { email: params.email , firstLogin : res.first },
                    })
                  }
                })

            }else if(res.code = 'notPhoneType') {
              
              this.$store.commit('loading', false)
              this.alert = true
              this.errors = '올바른 휴대폰 번호를 입력해주세요.' ;

            } else if (res.code === 'invalid') {
              this.$store.commit('loading', false)
              this.alert = true
              this.errors = this.$t('login.errors')
            } else throw res
          })
          .catch((error) => {
            this.$store.commit('loading', false)
            this.alert = true
            this.errors = this.$t('errorServer')
          })
      } else {
        this.$store.commit('loading', false)
        this.alert = true
        this.errors = this.$t('login.errors')
      }
    },
    async ensureGsiScript() {
      if (window.google && window.google.accounts && window.google.accounts.id) return
      const existing = document.querySelector('script[src="https://accounts.google.com/gsi/client"]')
      if (existing) {
        return new Promise((resolve) => {
          existing.addEventListener('load', () => resolve())
          existing.addEventListener('error', () => resolve())
        })
      }
      await new Promise((resolve) => {
        const script = document.createElement('script')
        script.src = 'https://accounts.google.com/gsi/client'
        script.async = true
        script.defer = true
        script.onload = () => resolve()
        script.onerror = () => resolve()
        document.head.appendChild(script)
      })
    },
    async fetchClientIp() {
      try {
        const resp = await fetch('https://api.ipify.org?format=json')
        const data = await resp.json()
        this.clientIp = data && data.ip ? data.ip : null
      } catch (e) {
        this.clientIp = null
      }
    },
    // Google Identity Services 초기화
    initGoogle() {
      const clientId =
        '248860432496-i39ism7980t5ccl58t9vs92lod0v35c2.apps.googleusercontent.com'

      const ready = () =>
        window.google && window.google.accounts && window.google.accounts.id

      if (!ready()) {
        // SDK 로딩 대기 (최대 10초)
        const timer = setInterval(() => {
          if (ready()) {
            clearInterval(timer)
            this.initGoogle()
          }
        }, 300)
        setTimeout(() => clearInterval(timer), 10000)
        return
      }

      const isCrossIso = window.crossOriginIsolated === true
      const uxMode = isCrossIso ? 'redirect' : 'popup'
      const loginUri = window.location.href.split('#')[0]

      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => this.handleGoogleCredential(response),
        ux_mode: uxMode,
        login_uri: uxMode === 'redirect' ? loginUri : undefined,
      })

      const target = document.getElementById('gsi-btn')
      if (target) {
        window.google.accounts.id.renderButton(target, {
          theme: 'outline',
          size: 'large',
          type: 'standard',
          shape: 'rect',
          text: 'signin_with',
          locale: 'ko_KR',
        })
      }
    },
    // 구글에서 전달한 Credential 처리
    handleGoogleCredential(response) {
      console.log('[Google Login] Credential received:', response);
      const { credential } = response || {}
      if (!credential) {
        console.error('[Google Login] No credential in response');
        return
      }

      const payload = this.parseJwt(credential)
      console.log('[Google Login] Parsed JWT:', payload);
      if (!payload || !payload.email) {
        this.alert = true
        this.errors = '구글 로그인에 실패했습니다.'
        return
      }

      this.$store.commit('loading', true)
      const params = {
        gmail: payload.email,
        exp: payload.exp,
        payload: payload,
      }
      console.log('[Google Login] Calling LOGING dispatch with:', params);

      this.$store
        .dispatch('LOGING', params)
        .then((res) => {
          console.log('[Google Login] LOGING response:', res);
          this.$store.commit('loading', false)

          if (!res || !res.token) {
            console.error('[Google Login] No token in response');
            this.alert = true
            this.errors = '구글 로그인 처리 중 오류가 발생했습니다.'
            return
          }

          console.log('[Google Login] Token received, is_new:', res.is_new);
          this.$store.commit('setAccessToken', res.token);

          this.$store.dispatch('FETCH_USERINFO').then(() => {
            console.log('[Google Login] User info fetched');
            if (res.is_new) {
              console.log('[Google Login] New user, redirecting to verify');
              this.$router.replace({
                name: 'verify',
                params: {
                  email: params.gmail,
                  firstLogin: true,
                  isGoogleLogin: true
                }
              })
            } else {
              console.log('[Google Login] Existing user, redirecting to home');
              this.$router.replace('home')
            }
          }).catch((err) => {
            console.error('[Google Login] FETCH_USERINFO error:', err);
            this.alert = true
            this.errors = '사용자 정보 조회 실패'
          })
        })
        .catch((e) => {
          console.error('[Google Login] LOGING dispatch error:', e)
          this.$store.commit('loading', false)
          this.alert = true
          this.errors = this.$t('errorServer')
        })
    },
    // JWT 디코드 (의존성 없이 단순 파서)
    parseJwt(token) {
      try {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        )
        console.log( "jsonPayload :: " , JSON.parse(jsonPayload))
        return JSON.parse(jsonPayload) ;
      } catch (e) {
        return null
      }
    },
    scrollTo(elem) {
      let target
      if (elem === 'password') target = this.$refs.password
      if (elem === 'email') target = this.$refs.email

      this.$vuetify.goTo(target)
    },
  },
}
</script>

<style scoped>
/* .login-container {
  padding: 4rem 2rem;
  height: 100%;
  max-width: 25rem;
  overflow: auto;
} */
.login-container {
  padding: 4rem 2rem;
  height: 100%;
  max-width: 25rem;
  overflow: auto;
  background: linear-gradient(
    to bottom,
    #f0f0f0,
    #797878
  ); /* 캡처 이미지의 그라데이션 색상 */
}

.web3pays-subtitle {
  font-size: 1.1rem; /* 설명 텍스트 크기 */
  line-height: 1.5;
}
.links {
  display: flex;
  align-items: center;
}
.link-item {
  margin-left: 1rem;
}
.links a {
  color: #000;
}
</style>
